import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import {
  type BreadcrumbProperties,
  type BreadcrumbRoute,
  HorizontalOverflow,
  Link,
  PageHeader,
  RadioPills,
  type RadioPillsProperties,
  Tabs,
  type TabsProperties,
  Title,
} from 'ui';

type P<T extends string> = {
  extra?: ReactNode;
  radioPills?: RadioPillsProperties<T>;
  routes?: BreadcrumbRoute[];
  tabs?: TabsProperties;
  title: ReactNode;
};

const DefaultPageHeader = <T extends string = string>({ extra, radioPills, routes, tabs, title }: P<T>) => {
  const { t } = useTranslation();

  const breadcrumb: BreadcrumbProperties = {
    itemRender({ path, title: itemTitle }) {
      return <Link to={path ?? ''}>{itemTitle}</Link>;
    },
    routes: routes?.map((route) => ({
      ...route,
      title: typeof route.title === 'string' ? t(route.title) : route.title,
    })),
  };

  return (
    <div className="default-page-header">
      <PageHeader
        breadcrumb={breadcrumb}
        className="default-page-header__main"
        extra={extra}
        // TODO: resolve other levels of title
        title={
          <Title className="default-page-header__main__title" marginBottom marginTop>
            {title}
          </Title>
        }
      />
      {radioPills && radioPills.items.length > 1 ? (
        <HorizontalOverflow>
          <RadioPills<T> {...radioPills} />
        </HorizontalOverflow>
      ) : null}

      {tabs ? <Tabs {...tabs} /> : null}
    </div>
  );
};

export default DefaultPageHeader;
